import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "container" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("header", null, [
  /*#__PURE__*/_createElementVNode("h2", null, "手続き編集")
], -1)
const _hoisted_3 = { class: "mt-5" }
const _hoisted_4 = { class: "d-flex justify-content-center my-2" }
const _hoisted_5 = /*#__PURE__*/_createTextVNode("戻る")
const _hoisted_6 = /*#__PURE__*/_createElementVNode("button", {
  type: "submit",
  class: "btn btn-success mx-2"
}, "更新", -1)

import { ref } from 'vue'
import { useRouter } from 'vue-router'
import { useMessenger } from '@/plugins/message'
import { useNicotto, ConciergeProcess } from '@/plugins/nicotto'
import ProcessForm from '@/components/forms/ConciergeProcess.vue'
import ButtonDelete from '@/components/ui/ButtonDelete.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'EditView',
  props: {
    id: null
  },
  setup(__props: any) {

const props = __props as {
  id: string
}



const router = useRouter()
const nicotto = useNicotto()
const messenger = useMessenger()

const process = ref<ConciergeProcess>(new ConciergeProcess())
nicotto.concierge.getProcess(props.id)
  .then(data => {
    process.value = data
  })

const onDeleteConfirmed = async() => {
  try {
    await nicotto.concierge.deleteProcess(process.value)
    messenger.set('concierge.processes.deleteSucceeded')
    router.push('/concierge/processes')
  } catch (err) {
    messenger.set('concierge.processes.deleteFailed')
  }
}

const save = async() => {
  try {
    await nicotto.concierge.updateProcess(process.value)
    messenger.set('concierge.processes.updateSucceeded')
    router.push('/concierge/processes')
  } catch (err: any) {
    if (err?.errors?.filter((e: any) => e.message.indexOf('data is already exists') !== -1).length > 0) {
      messenger.set('concierge.processes.saveFailedAlreadyExists')
    } else {
      messenger.set('concierge.processes.updateFailed')
    }
  }
}

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createVNode(ProcessForm, {
        modelValue: process.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((process).value = $event)),
        onSubmit: save
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_4, [
            _createVNode(_component_router_link, {
              to: "/concierge/processes",
              class: "btn btn-secondary mx-2",
              role: "button"
            }, {
              default: _withCtx(() => [
                _hoisted_5
              ]),
              _: 1
            }),
            _createVNode(ButtonDelete, { onDeleteConfirmed: onDeleteConfirmed }),
            _hoisted_6
          ])
        ]),
        _: 1
      }, 8, ["modelValue"])
    ])
  ]))
}
}

})